import { render } from "./InstallationSlider.vue?vue&type=template&id=7b9fd896&scoped=true"
import script from "./InstallationSlider.vue?vue&type=script&lang=js"
export * from "./InstallationSlider.vue?vue&type=script&lang=js"

import "./InstallationSlider.vue?vue&type=style&index=0&id=7b9fd896&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9fd896"]])

export default __exports__